/* Webinar css*/
import styled from 'styled-components';

export const WebinarWrapper = styled.div`

.webinar-button {
    width: 100%;
    font-size: 15px;
    height: 35px;
    line-height: 20px;
  border-radius: 3px;
  background-color: #083ac8;
  border-color: #083ac8;
  font-size: 15px;
  font-weight: normal;
  letter-spacing: 0.21px;
  text-align: center;
}

.webinar h6 {
    font-size: 12px;
    color: #333333;
    font-weight: normal;
}

.webinar h5 {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.4;
    color: #333333;
}

.webinar-sec .card-body h5 {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    line-height: 1.43;
    color: #333333;
    margin: 12px 0px 20px 0;
}
.webinar-sec{
    // height:100%;
}
.promo {
    padding: 50px;
    text-align: center;
    font-size: 16px;
}`;